<template>
    <div>
        <!-- widgets -->
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="card card-statistic-1">
                    <div class="card-icon bg-warning">
                        <i class="fas fa-tasks"></i>
                    </div>
                    <div class="card-wrap">
                        <div class="card-header">
                            <h4>Em Andamento</h4>
                        </div>
                        <div class="card-body">
                            <div
                                v-if="widgets.pending == 0 && loading"
                                class="spinner-border spinner-border spinner-border-sm"
                                role="status"
                            ></div>
                            <div v-else>{{ widgets.pending }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="card card-statistic-1">
                    <div class="card-icon bg-danger">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="card-wrap">
                        <div class="card-header">
                            <h4>Atividade Não Criada</h4>
                        </div>
                        <div class="card-body">
                            <div
                                v-if="widgets.colaborator == 0 && loading"
                                class="spinner-border spinner-border spinner-border-sm"
                                role="status"
                            ></div>
                            <div v-else>{{ widgets.colaborator }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="card card-statistic-1">
                    <div class="card-icon bg-danger">
                        <i class="fas fa-times-circle"></i>
                    </div>
                    <div class="card-wrap">
                        <div class="card-header">
                            <h4>Não Executada</h4>
                        </div>
                        <div class="card-body">
                            <div
                                v-if="widgets.not == 0 && loading"
                                class="spinner-border spinner-border spinner-border-sm"
                                role="status"
                            ></div>
                            <div v-else>{{ widgets.not }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="card card-statistic-1">
                    <div class="card-icon bg-secondary">
                        <i class="fas fa-file-alt"></i>
                    </div>
                    <div class="card-wrap">
                        <div class="card-header">
                            <h4>Outros</h4>
                        </div>
                        <div class="card-body">
                            <div
                                v-if="widgets.others == 0 && loading"
                                class="spinner-border spinner-border spinner-border-sm"
                                role="status"
                            ></div>
                            <div v-else>{{ widgets.others }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end widgets -->

        <div class="row section-top">
            <div class="col-md-12 pad0">
                <p class="section-lead">
                    Lista de todas Ocorrências cadastradas!
                </p>
                <a
                    href="/admin/occurrences/create"
                    class="btn btn-outline-success float-right"
                    ><i class="fas fa-plus"></i>&nbsp;Nova</a
                >
                <a
                    class="btn btn-outline-warning float-right"
                    data-toggle="collapse"
                    href="#panelFilter"
                    role="button"
                    aria-expanded="false"
                    aria-controls="panelFilter"
                    ><i class="fas fa-filter"></i>&nbsp;Filtrar</a
                >
                <div class="dropdown float-right">
                    <button
                        class="btn btn-outline-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i class="fas fa-download"></i>
                        Exportar
                    </button>
                    <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <a
                            class="dropdown-item"
                            href="#"
                            @click="exportData('pdf')"
                            >PDF</a
                        >
                        <a
                            class="dropdown-item"
                            href="#"
                            @click="exportData('csv')"
                            >Excel</a
                        >
                        <div class="dropdown-divider"></div>
                        <a
                            class="dropdown-item"
                            href="#"
                            @click="
                                $refs.gridfullexport.showModal(
                                    'occurrences',
                                    'occurrences'
                                )
                            "
                            >Completo</a
                        >
                    </div>
                </div>
            </div>
        </div>

        <!-- filter -->
        <div class="row">
            <div class="col-md-12">
                <div class="collapse" id="panelFilter">
                    <div class="card card-body">
                        <div class="row">
                            <!-- company id -->
                            <div class="col-md-6 mt-2">
                                <div class="form-group">
                                    <label
                                        class="form-control-label"
                                        for="input-work_place_id"
                                        >Empresa</label
                                    >
                                    <v-select
                                        :options="filterCompanies"
                                        label="corporate_name"
                                        v-bind:class="{
                                            'is-invalid': errors.company
                                        }"
                                        :reduce="
                                            corporate_name => corporate_name.id
                                        "
                                        v-model="filterItems.company_id"
                                        @input="validateFilterCompany()"
                                    ></v-select>
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.company"
                                    >
                                        <p>{{ errors.company[0] }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- contract -->
                            <div class="col-md-6 mt-2">
                                <div class="form-group">
                                    <label
                                        class="form-control-label"
                                        for="input-work_place_id"
                                        >Contrato</label
                                    >
                                    <v-select
                                        :options="filterContracts"
                                        label="corporate_name"
                                        v-bind:class="{
                                            'is-invalid': errors.contract
                                        }"
                                        :reduce="
                                            corporate_name => corporate_name.id
                                        "
                                        v-model="filterItems.contract_id"
                                    ></v-select>
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.contract"
                                    >
                                        <p>{{ errors.contract[0] }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- work_place_id -->
                            <div class="col-md-6 mt-2">
                                <div class="form-group">
                                    <label
                                        class="form-control-label"
                                        for="input-work_place_id"
                                        >Local de Trabalho</label
                                    >
                                    <v-select
                                        :options="filterWorkplaces"
                                        label="corporate_name"
                                        v-bind:class="{
                                            'is-invalid': errors.workplace
                                        }"
                                        :reduce="
                                            corporate_name => corporate_name.id
                                        "
                                        v-model="filterItems.work_place_id"
                                        @input="validateFilterWorkplace()"
                                    ></v-select>
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.workplace"
                                    >
                                        <p>{{ errors.workplace[0] }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- sublocal -->
                            <div class="col-md-6 mt-2">
                                <div class="form-group">
                                    <label
                                        class="form-control-label"
                                        for="input-sublocal"
                                        >Sublocal</label
                                    >
                                    <v-select
                                        :options="filterSublocal"
                                        label="corporate_name"
                                        v-bind:class="{
                                            'is-invalid': errors.sublocal
                                        }"
                                        :reduce="
                                            corporate_name => corporate_name.id
                                        "
                                        v-model="filterItems.sublocal_id"
                                        @input="validateFilterSublocal()"
                                    ></v-select>
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.sublocal"
                                    >
                                        <p>{{ errors.sublocal[0] }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- colaborator_id -->
                            <div class="col-md-6 mt-2">
                                <label
                                    class="form-control-label"
                                    for="input-colaborator_id"
                                    >Colaborador</label
                                >
                                <v-select
                                    :options="filterColaborators"
                                    label="name"
                                    v-model="filterItems.colaborator_id"
                                    :reduce="name => name.colaborator_id"
                                ></v-select>
                            </div>

                            <!-- expected_date -->
                            <div class="col-md-3 mt-2">
                                <label
                                    class="form-control-label"
                                    for="input-expected_date"
                                    >Data Prevista</label
                                >
                                <input
                                    type="date"
                                    id="input-expected_date"
                                    class="form-control"
                                    placeholder="Data prevista"
                                    v-model="filterItems.expected_date"
                                    required="false"
                                />
                            </div>

                            <!-- expected_time -->
                            <div class="col-md-3 mt-2">
                                <label
                                    class="form-control-label"
                                    for="input-expected_time"
                                    >Hora Prevista</label
                                >
                                <input
                                    type="time"
                                    id="input-expected_time"
                                    class="form-control"
                                    placeholder="Hora Prevista"
                                    v-model="filterItems.expected_time"
                                    required="false"
                                />
                            </div>

                            <!-- title -->
                            <div class="col-md-8 mt-4">
                                <label
                                    class="form-control-label"
                                    for="input-title"
                                    >Título</label
                                >
                                <input
                                    type="text"
                                    id="input-title"
                                    class="form-control"
                                    placeholder="Título"
                                    v-model="filterItems.title"
                                    required="false"
                                />
                            </div>

                            <!-- status id -->
                            <div class="col-md-4 mt-4">
                                <label
                                    class="form-control-label"
                                    for="input-item_id"
                                    >Status</label
                                >
                                <v-select
                                    :options="filterStatus"
                                    label="name"
                                    :reduce="name => name.id"
                                    v-model="filterItems.status_id"
                                ></v-select>
                            </div>

                            <!-- item_id -->
                            <div class="col-md-12 mt-4">
                                <label
                                    class="form-control-label"
                                    for="input-item_id"
                                    >Item</label
                                >
                                <v-select
                                    :options="items"
                                    label="name"
                                    :reduce="name => name.id"
                                    v-model="filterItems.item_id"
                                ></v-select>
                            </div>

                            <div class="col-md-12 mt-4 text-right">
                                <button
                                    class="btn btn-success"
                                    @click="filter()"
                                >
                                    FILTRAR
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end filters -->

        <div class="row">
            <div class="col">
                <!-- table -->
                <div class="card p-4">
                    <vue-good-table
                        v-if="ocurrenciesItems.length"
                        :columns="tableColumns"
                        :rows="ocurrenciesItems"
                        :pagination-options="{
                            enabled: true,
                            perPage: 500
                        }"
                        :search-options="{
                            enabled: true,
                            placeholder: 'Buscar..'
                        }"
                        styleClass="vgt-table"
                    >
                        <template slot="pagination-bottom">
                            <div
                                style="display: flex; justify-content: space-between; align-items: center;"
                            >
                                <div
                                    style="display: flex; align-items: center; justify-content: center; margin-top: 8px;"
                                >
                                    <label
                                        style="font-size: 12px; margin-top: 8px"
                                    >
                                        {{ tablePagination.rowsPerPageLabel }}:
                                    </label>
                                    <select
                                        v-model="currentPerPage"
                                        @change="
                                            event =>
                                                changePerPage(
                                                    event.target.value
                                                )
                                        "
                                        style="margin-left: 8px; font-size: 12px; font-weight: bold; border: none;"
                                    >
                                        <option
                                            v-for="option in perPageOptions"
                                            :key="option"
                                            :value="option"
                                            >{{ option }}</option
                                        >
                                    </select>
                                </div>

                                <div
                                    style="display: flex; align-items: center; margin-top: 8px;"
                                >
                                    <span style="font-size: 12px;"
                                        >{{ from }} - {{ to }} de
                                        {{ total }}</span
                                    >

                                    <div
                                        style="display: flex; gap: 8px; margin-left: 16px;"
                                    >
                                        <div
                                            @click="prevPage"
                                            :style="{
                                                cursor: canGoPrev
                                                    ? 'pointer'
                                                    : 'not-allowed',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                color: canGoPrev
                                                    ? 'inherit'
                                                    : '#ccc'
                                            }"
                                            :disabled="!canGoPrev"
                                        >
                                            ◀
                                            {{ tablePagination.prevLabel }}
                                        </div>
                                        <div
                                            @click="nextPage"
                                            :style="{
                                                cursor: canGoNext
                                                    ? 'pointer'
                                                    : 'not-allowed',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                color: canGoNext
                                                    ? 'inherit'
                                                    : '#ccc'
                                            }"
                                            :disabled="!canGoNext"
                                        >
                                            {{ tablePagination.nextLabel }}
                                            ▶
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == '_sector'">
                                <div v-if="props.row.activity">
                                    <div v-if="props.row.activity.sector">
                                        {{ props.row.activity.sector.name }}
                                    </div>
                                    <div v-else>
                                        <div v-if="props.row.activity.items">
                                            <div v-if="props.row.activity.items.inventory">
                                                <div v-if="props.row.activity.items.inventory.sectors">
                                                    {{ props.row.activity.items.inventory.sectors.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                            <span v-if="props.column.field == '_subsector'">
                                <div v-if="props.row.activity">
                                    <div v-if="props.row.activity.subsector">
                                        {{ props.row.activity.subsector.name }}
                                    </div>
                                    <div v-else>
                                        <div v-if="props.row.activity.items">
                                            <div v-if="props.row.activity.items.inventory">
                                                <div v-if="props.row.activity.items.inventory.subsectors">
                                                    {{ props.row.activity.items.inventory.subsectors.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                            <span v-if="props.column.field == '_colaborator'">
                                {{ validateColaborators(props.row) }}
                            </span>
                            <span v-if="props.column.field == '_status'">
                                {{ validateStatus(props.row) }}
                            </span>
                            <span v-if="props.column.field == '_done_date'">
                                <div v-if="props.row.activity">
                                    <div
                                        v-if="
                                            props.row.activity.done_datetime !== null &&
                                                props.row.activity.done_datetime !==
                                                    undefined
                                        "
                                    >
                                        {{
                                            props.row.activity.done_datetime
                                                | moment("DD/MM/YYYY")
                                        }}
                                    </div>
                                </div>
                            </span>
                            <span v-if="props.column.field == '_done_time'">
                                <div v-if="props.row.activity">
                                    <div
                                        v-if="
                                            props.row.activity.done_datetime !== null &&
                                                props.row.activity.done_datetime !==
                                                    undefined
                                        "
                                    >
                                        {{
                                            props.row.activity.done_datetime
                                                | moment("HH:mm:ss")
                                        }}
                                    </div>
                                </div>
                            </span>
                            <span v-if="props.column.field == 'actions'">
                                <div>
                                    <button
                                        class="btn btn-sm btn-outline-warning"
                                        title="Comentários"
                                        @click="viewOccurrenceComments(props.row)"
                                    >
                                        <i class="fas fa-list-ul"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-success"
                                        v-if="props.row.incident_status_id == 9"
                                        title="Criar Atividade"
                                        @click="newActivity(props.row)"
                                    >
                                        <i class="fas fa-plus"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-secondary"
                                        v-if="props.row.incident_status_id == 4"
                                        title="Finalizar"
                                        @click="doneData(props.row)"
                                    >
                                        <i class="fas fa-check"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-secondary"
                                        v-if="props.row.incident_status_id != 9"
                                        title="Visualizar Atividade"
                                        @click="viewData(props.row)"
                                    >
                                        <i class="far fa-eye"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-success"
                                        v-if="userCan.edit"
                                        @click="editData(props.row)"
                                        title="Editar"
                                    >
                                        <i class="far fa-edit"></i>
                                    </button>
                                    <!-- <button class="btn btn-sm btn-outline-danger" v-if="userCan.delete" @click="deleteData(props.row.id, props.row.index)" title="Deletar"><i class="far fa-trash-alt"></i></button> -->
                                </div>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                    </vue-good-table>
                    <div
                        v-else-if="!ocurrenciesLoading"
                        class="text-center p-3 text-muted"
                    >
                        <h5>Nenhuma ocorrência cadastrada!</h5>
                    </div>
                </div>

                <div
                    class="text-center p-4 text-muted"
                    v-if="loading || ocurrenciesLoading"
                >
                    <h5>Carregando...</h5>
                    <p>Aguarde até que os dados sejam carregados...</p>
                </div>
            </div>
        </div>

        <!-- modal -->
        <div
            class="modal fade"
            id="modalDoneOccurrence"
            tabindex="-1"
            aria-labelledby="modalDoneOccurrenceLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalDoneOccurrenceLabel">
                            Finalizar Ocorrência Manualmente
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="saveData">
                            <div class="row">
                                <!-- info -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label
                                            class="form-control-label"
                                            for="input-workplace_id"
                                            >Informações</label
                                        >
                                        <textarea
                                            class="form-control"
                                            v-model="modalOccurrence.info"
                                            required
                                        ></textarea>
                                    </div>
                                </div>

                                <!-- file -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label
                                            class="form-control-label"
                                            for="input-file"
                                            >Arquivo</label
                                        >
                                        <div class="custom-file">
                                            <input
                                                type="file"
                                                class="custom-file-input"
                                                v-bind:class="{
                                                    'is-invalid': errors.file
                                                }"
                                                id="file"
                                                name="file"
                                                ref="file"
                                                lang="pt"
                                                v-on:change="handleFileUpload()"
                                            />
                                            <label
                                                class="custom-file-label"
                                                for="file"
                                                >{{ fileName }}</label
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-right">
                                <button type="submit" class="btn btn-success">
                                    CONCLUIR
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- end modal -->

        <!-- modal history comments -->
        <div class="modal fade" id="modalOccurenceComment" tabindex="-1" aria-labelledby="modalOccurenceCommentLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalOccurenceCommentLabel">Comentários da Ocorrência</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <!-- form new comment -->
                        <form v-on:submit.prevent="saveComment" v-if="selectedOccurrence.incident_status_id != 5 && selectedOccurrence.incident_status_id != 6">

							<div class="row">

                                <h5 style="margin: 10px 15px 15px 15px; font-size: 14px; padding: 15px;background-color: #F5F5F5; border: 1px solid #BDBDBD; border-radius:6px;display:block;width:100%;">Ocorrência: <b>{{ selectedOccurrence.title }}</b></h5>

                                <!-- comment -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-control-label" for="input-comment">Comentário</label>
                                        <textarea type="text" id="input-comment" class="form-control" placeholder="Digite um comentário para adicionar à ocorrência" v-model="modalComment.comment" style="height: 130px !important;resize:none;"></textarea>
                                    </div>
                                </div>

                                <!-- file -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-control-label" for="input-file">Arquivo</label>
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="fileComment" name="fileComment" ref="fileComment" lang="pt" v-on:change="handleFileCommentUpload()">
                                            <label class="custom-file-label" for="fileComment">{{modalComment.fileName}}</label>
                                        </div>
                                    </div>
                                </div>
                        
                            </div>

                            <div class="text-right">
                                <button type="submit" class="btn btn-success">ADICIONAR COMENTÁRIO</button>
                            </div>
                        </form>


                        <vue-good-table v-if="occurrenceComments.length > 0"
                            :columns="tableColumnsComments"
                            :rows="occurrenceComments"
                            :pagination-options="tablePagination"
                            :search-options="{
                            enabled: true,
                            placeholder: 'Buscar..'
                            }"
                            class="mt-4"
                            styleClass="vgt-table"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == '_actions'" class="actions">
                                    <button class="btn btn-sm btn-outline-secondary" title="Ver Anexo" v-if="props.row.file" @click="viewCommentFile(props.row)">
                                        <i class="fas fa-file"></i>
                                    </button>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                            <template slot="pagination-bottom">
                                <table-pagination-component :_options="tablePaginationOptionsComments" @paginate="paginationComments"></table-pagination-component>
                            </template>
                        </vue-good-table>
                        <div v-else class="text-center p-3 text-muted">
                            <h5>Nenhum comentário encontrado!</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <gridfullexport-component
            ref="gridfullexport"
        ></gridfullexport-component>

        <vue-loading
            color="#212121"
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="fullPage"
        ></vue-loading>
    </div>
</template>

<script>
import ApiService from "../../apiservice.js";
import configData from "../../config.js";
import ExportGrid from "../../exportgrid.js";
export default {
    mixins: [ApiService, configData, ExportGrid],
    props: ["permissions"],
    data() {
        return {
            colaborators: [],
            items: [],
            status: [],
            fileName: "",
            filterColaborators: [],
            filterCompanies: [],
            filterContracts: [],
            filterWorkplaces: [],
            filterSublocal: [],
            filterStatus: [],
            templates: [],
            colaborators: [],
            colaboratorgroups: [],
            ocurrenciesItems: [],
            fullPage: true,
            errors: [],
            loading: false,
            modalOccurrence: {},
            modalComment: {
                comment: "",
                file: null,
                fileName: "Clique para selecionar o arquivo"
            },
            occurrenceComments: [],
            selectedOccurrence: {},
            widgets: {
                pending: 0,
                colaborator: 0,
                not: 0,
                others: 0
            },
            ocurrenciesLoading: false,
            tablePagination: {
                enabled: true,
                nextLabel: "próxima",
                prevLabel: "anterior",
                rowsPerPageLabel: "Registros por página",
                tofLabel: "de",
                pageLabel: "página",
                allLabel: "Todos",
                dropdownAllowAll: false
            },
            perPageOptions: [10, 50, 100, 500],
            currentPage: 1,
            currentPerPage: 10,
            total: null,
            from: 0,
            to: 0,
            tableColumns: [
                { 
                    label: "ID",
                    field: "id"
                },{
                    label: "Título",
                    field: "title"
                },{
                    label: "Empresa",
                    field: "company.corporate_name"
                },{
                    label: "Sublocal de Trabalho",
                    field: "work_places.corporate_name"
                },{
                    label: "Setor",
                    field: "_sector"
                },{
                    label: "Subsetor",
                    field: "_subsector"
                },{
                    label: "Colaborador",
                    field: "_colaborator"
                },{
                    label: "Data Prevista",
                    field: "expected_date",
                    type: "date",
                    dateInputFormat: "yyyy-MM-dd",
                    dateOutputFormat: "dd/MM/yyyy"
                },{
                    label: "Hora Prevista",
                    field: "expected_time"
                },{
                    label: "Status",
                    field: "_status"
                },{
                    label: "Data (Concluída)",
                    field: "_done_date"
                },
                {
                    label: "Hora (Concluída)",
                    field: "_done_time"
                },{
                    label: "Ações",
                    field: "actions",
                    sortable: false,
                    width: "150px"
                }
            ],
            tableColumnsComments: [
                {
                    label: "Comentário",
                    field: "comment"
                },{
                    label: "Colaborador",
                    field: "colaborator"
                },{
                    label: "Criado em",
                    field: 'created_at',
                    type: 'date',
                    dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
                    dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
                },{
                    label: "Ações",
                    field: "_actions",
                    sortable: false,
                    width: "50px"
                }
            ],
            tablePaginationOptionsComments: {
                currentPage: 1,
                currentPerPage: 10,
                from: 0,
                to: 0,
                total: null
            },
            selectedOccurrence: {},
            filterItems: {},
            userCan: ""
        };
    },
    mounted() {
        this.loadFilterCompanies();
        this.loadFilterStatus();

        // this.loadColaborators();
        // this.loadFilterStatus();

        this.userCan = JSON.parse(this.permissions);
        if (this.userCan.list) {
            this.loadItems();
        }
    },
    watch: {
        currentPage: "loadItems",
        currentPerPage: "loadItems"
    },
    computed: {
        canGoNext() {
            return this.currentPage * this.currentPerPage < this.total;
        },
        canGoPrev() {
            return this.currentPage > 1;
        }
    },
    methods: {
        handleFileCommentUpload(){
            this.modalComment.file = this.$refs.fileComment.files[0];
            this.modalComment.fileName = this.$refs.fileComment.files[0].name;
        },
        paginationComments(page){
            this.tablePaginationOptionsItems = {
                currentPage: page.options.currentPage,
                currentPerPage: page.options.currentPerPage,
                from: page.options.from,
                to: page.options.to,
                total: page.options.total
            };
            this.loadComments();
        },
        changePerPage(value) {
            this.currentPerPage = value;
        },
        nextPage() {
            if (this.canGoNext) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.canGoPrev) {
                this.currentPage--;
            }
        },
        handleFileUpload() {
            this.modalOccurrence.file = this.$refs.file.files[0];
            this.modalOccurrence.fileName = this.$refs.file.files[0].name;
            this.fileName = this.$refs.file.files[0].name;
        },
        doneData(item) {
            this.selectedOccurrence = item;
            $("#modalDoneOccurrence").modal("show");
        },
        exportData(type) {
            var tempForm = $("#vgt-table");
            if (type == "pdf") {
                this._exportPDF("Ocorrências", [10], tempForm, [
                    "ID",
                    "Título",
                    "Empresa",
                    "Sublocal de Trabalho",
                    "Setor",
                    "Subsetor",
                    "Colaborador",
                    "Data Prevista",
                    "Hora Prevista",
                    "Status",
                    "Data (Concluída)",
                    "Hora (Concluída)"
                ]);
            } else {
                this._exportExcel("Ocorrências", [10], tempForm, [
                    "ID",
                    "Título",
                    "Empresa",
                    "Sublocal de Trabalho",
                    "Setor",
                    "Subsetor",
                    "Colaborador",
                    "Data Prevista",
                    "Hora Prevista",
                    "Status",
                    "Data (Concluída)",
                    "Hora (Concluída)"
                ]);
            }
        },
        loadFilterItems() {
            let _this = this;
            _this.tempItems = [];
            _this.items = [];
            _this.loading = true;

            let dataFilter = {
                "company_id" : _this.filterItems.company_id,
                "contract_id" : _this.filterItems.contract_id,
                "work_place_id" : _this.filterItems.work_place_id,
                "sublocal_id" : _this.filterItems.sublocal_id
            };

            axios.post("/admin/items/select", dataFilter).then((res) => {
                _this.tempItems = _this.tempItems.concat(res.data.data);
                _this.items.push({
                    name: "Genérico",
                    id: 0
                });
                _this.items.push(...res.data.data);
                _this.loading = false;
            })
            .catch(err => {
                _this.loading = false;
            });
        },
        loadFilterStatus() {
            let _this = this;
            _this.ocurrenciesItems = [];
            _this.loading = true;
            axios
                .get("/admin/activitystatus")
                .then(res => {
                    _this.filterStatus = _this.filterStatus.concat(res.data);
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        loadFilterColaborators() {
            let _this = this;
            _this.filterColaborators = [];
            _this.tempColaborators = [];
            _this.loading = true;
            axios
                .get(
                    "/admin/companycolaborators/" +
                        _this.filterItems.company_id +
                        "/search"
                )
                .then(res => {
                    res.data.map(row => {
                        row.name = row.colaborators.users.profile.name;
                        _this.tempColaborators.push(row);
                    });
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        loadFilterColaboratorGroups() {
            let _this = this;
            _this.filterColaboratorGroups = [];
            _this.tempColaboratorsGroups = [];
            _this.loading = true;
            axios
                .get(
                    "/admin/colaboratorgroups/" +
                        _this.filterItems.company_id +
                        "/search"
                )
                .then(res => {
                    _this.tempColaboratorsGroups = _this.tempColaboratorsGroups.concat(
                        res.data
                    );
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        loadFilterContracts() {
            let _this = this;
            _this.filterContracts = [];
            _this.loading = true;
            axios
                .get(
                    "/admin/companycontracts/" +
                        _this.filterItems.company_id +
                        "/search"
                )
                .then(res => {
                    res.data.map(rowContract => {
                        _this.filterContracts.push(rowContract.contracts);
                    });
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        loadFilterCompanies() {
            let _this = this;
            axios
                .get("/admin/companies")
                .then(res => {
                    _this.filterCompanies = _this.filterCompanies.concat(
                        res.data
                    );
                })
                .catch(err => {});
        },
        loadItems() {
            let _this = this;
            _this.loading = true;
            _this.ocurrenciesItems = [];
            let dataFilter = {
                title: _this.filterItems.title,
                expected_date: _this.filterItems.expected_date,
                expected_time: _this.filterItems.expected_time,
                time: _this.filterItems.time,
                duration: _this.filterItems.duration,
                item_id: _this.filterItems.item_id,
                status_id: _this.filterItems.status_id,
                work_place_id: _this.filterItems.work_place_id,
                template_id: _this.filterItems.template_id,
                colaborator_id: _this.filterItems.colaborator_id,
                company_id: _this.filterItems.company_id,
                sublocal_id: _this.filterItems.sublocal_id,
                contract_id: _this.filterItems.contract_id,
                last: ""
            };
            axios
                .post("/admin/occurrences/filter", dataFilter, {
                    params: {
                        page: _this.currentPage,
                        perPage: _this.currentPerPage
                    }
                })
                .then(res => {
                    _this.loading = false;

                    const { data, total, from, to } = res.data.data;
                    _this.ocurrenciesItems = [...data];
                    _this.total = total;
                    _this.from = from;
                    _this.to = to;

                    // _this.ocurrenciesItems = [];
                    // _this.ocurrenciesItems = data;
                })
                .catch(err => {
                    _this.loading = false;

                    //call function in ApiService to validate error
                    _this._api_validateError(err);
                });
        },
        loadFilterStatus() {
            let _this = this;
            _this.ocurrenciesItems = [];
            _this.loading = true;
            axios
                .get("/admin/incidentstatus")
                .then(res => {
                    _this.filterStatus = _this.filterStatus.concat(res.data);
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        loadColaborators() {
            let _this = this;
            _this.loading = true;
            axios
                .get("/admin/colaborators")
                .then(res => {
                    _this.colaborators = _this.colaborators.concat(res.data);
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        filter() {
            let _this = this;
            _this.loading = true;
            _this.ocurrenciesItems = [];
            let dataFilter = {
                title: _this.filterItems.title,
                expected_date: _this.filterItems.expected_date,
                expected_time: _this.filterItems.expected_time,
                time: _this.filterItems.time,
                duration: _this.filterItems.duration,
                item_id: _this.filterItems.item_id,
                status_id: _this.filterItems.status_id,
                work_place_id: _this.filterItems.work_place_id,
                template_id: _this.filterItems.template_id,
                colaborator_id: _this.filterItems.colaborator_id,
                company_id: _this.filterItems.company_id,
                sublocal_id: _this.filterItems.sublocal_id,
                contract_id: _this.filterItems.contract_id,
                last: ""
            };
            axios
                .post("/admin/occurrences/filter", dataFilter, {
                    params: {
                        page: _this.currentPage,
                        perPage: _this.currentPerPage
                    }
                })
                .then(res => {
                    _this.loading = false;

                    const { data, total, from, to } = res.data.data;
                    _this.ocurrenciesItems = [...data];
                    _this.total = total;
                    _this.from = from;
                    _this.to = to;

                    // _this.ocurrenciesItems = [];
                    // _this.ocurrenciesItems = data;
                })
                .catch(err => {
                    _this.loading = false;

                    //call function in ApiService to validate error
                    _this._api_validateError(err);
                });
        },
        editData(item) {
            location.href = "/admin/occurrences/" + item.id + "/edit";
        },
        saveData() {
            let _this = this;
            _this.loading = true;

            let formData = new FormData();
            formData.append("info", _this.modalOccurrence.info);
            formData.append("file", _this.modalOccurrence.file);

            axios
                .post(
                    "/admin/occurrences/" +
                        this.selectedOccurrence.id +
                        "/done",
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                )
                .then(res => {
                    _this.loading = false;

                    //call function in ApiService to validate success
                    _this._api_validateSuccess(res, true);
                })
                .catch(err => {
                    _this.loading = false;

                    $("#modalDoneOccurrence").modal("hide");

                    //call function in ApiService to validate error
                    _this._api_validateError(err);
                });
        },
        newActivity(item) {
            let _this = this;

            //show alert confirmation
            _this
                .$swal({
                    title: "Criar Atividade da Ocorrência",
                    text:
                        "Tem certeza que deseja criar uma Atividade para essa Ocorrência?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Criar",
                    cancelButtonText: "Cancelar"
                })
                .then(alertConfirm => {
                    //validate isConfirmed
                    if (alertConfirm.isConfirmed) {
                        //remove
                        axios
                            .get("/admin/occurrences/" + item.id + "/activity")
                            .then(res => {
                                //call function in ApiService to validate success
                                _this._api_validateSuccess(res, true);
                            })
                            .catch(err => {
                                _this.loading = false;

                                //call function in ApiService to validate error
                                _this._api_validateError(err);
                            });
                    } //end validate isConfirmed
                });
            //end alert confirmation
        },
        viewData(item) {
            location.href = "/admin/occurrences/" + item.id;
            // let _this = this;
            // _this.loading = true;
            // axios.get("/admin/occurrences/"+item.id).then((res) => {

            // 	_this.loading = false;

            // 	location.href = res.data.route;

            // }).catch((err) => {

            // 	_this.loading = false;

            // 	//call function in ApiService to validate error
            // 	_this._api_validateError(err);

            // });
        },
        resetForm() {
            this.activity = {
                title: "",
                description: "",
                details: "",
                expected_date: "",
                expected_time: "",
                time: "",
                duration: "",
                item_id: "",
                work_place_id: "",
                template_id: "",
                colaborator_id: ""
            };
        },
        validateColaborators(item) {
            let _this = this;
            var returnMessage = "";
            //item.colaborators.map((rowColaborator) => {
            _this.colaborators.map(row => {
                if (row.id == item.colaborator_id) {
                    returnMessage += row.users.profile.name + ", ";
                }
            });
            //});
            return returnMessage;
        },
        validateStatus(item) {
            let _this = this;
            var returnMessage = "";
            _this.filterStatus.map(row => {
                if (row.id == item.incident_status_id) {
                    returnMessage = row.name;
                }
            });
            return returnMessage;
        },
        validateFilterCompany() {
            let _this = this;
            _this.loading = true;

            _this.filterWorkplaces = [];
            axios
                .get(
                    "/admin/companyworkplaces/" +
                        _this.filterItems.company_id +
                        "/search"
                )
                .then(res => {
                    res.data.map(rowReturn => {
                        _this.filterWorkplaces = _this.filterWorkplaces.concat(
                            rowReturn.work_places
                        );
                    });
                    _this.loadFilterContracts();
                    _this.loadFilterColaborators();
                    _this.loadFilterColaboratorGroups();
                })
                .catch(err => {});
            this.loading = false;
        },
        validateFilterWorkplace() {
            let _this = this;

            _this.filterSublocal = [];
            axios
                .get(
                    "/admin/workplacesublocal/" +
                        _this.filterItems.work_place_id +
                        "/search"
                )
                .then(res => {
                    res.data.map(rowSublocal => {
                        _this.filterSublocal.push({
                            corporate_name: rowSublocal.sublocal.corporate_name,
                            id: rowSublocal.sublocal_id
                        });
                    });
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        validateFilterSublocal() {
            let _this = this;
            _this.loading = true;
            _this.loadFilterItems();

            axios
                .get(
                    "/admin/companyworkplacecolaborators/" +
                        _this.filterItems.company_id +
                        "/search"
                )
                .then(res => {
                    res.data.map(itemWorkplaceColaborator => {
                        if (
                            itemWorkplaceColaborator.work_place_id ==
                            _this.filterItems.work_place_id
                        ) {
                            //read all colaborators
                            _this.tempColaborators.map(itemColaborator => {
                                if (
                                    itemColaborator.colaborator_id ==
                                    itemWorkplaceColaborator.colaborator_id
                                ) {
                                    if (
                                        !_this.filterColaborators.some(
                                            data =>
                                                data.id === itemColaborator.id
                                        )
                                    ) {
                                        _this.filterColaborators.push(
                                            itemColaborator
                                        );
                                    }
                                }
                            });

                            //read all colaborator groups
                            _this.tempColaboratorsGroups.map(
                                itemColaboratorGroup => {
                                    if (
                                        itemColaboratorGroup.id ==
                                        itemWorkplaceColaborator.colaborator_group_id
                                    ) {
                                        if (
                                            !_this.filterColaboratorGroups.some(
                                                data =>
                                                    data.id ===
                                                    itemColaboratorGroup.id
                                            )
                                        ) {
                                            _this.filterColaboratorGroups.push(
                                                itemColaboratorGroup
                                            );
                                        }
                                    }
                                }
                            );

                            // _this.tempItems.map(rowItem => {
                            //     if (
                            //         rowItem.inventory !== null &&
                            //         rowItem.inventory !== undefined
                            //     ) {
                            //         if (
                            //             rowItem.inventory.work_place_id ==
                            //             _this.filterItems.sublocal_id
                            //         ) {
                            //             var exists = false;
                            //             _this.items.map(rowNewItem => {
                            //                 if (rowNewItem.id == rowItem.id) {
                            //                     exists = true;
                            //                 }
                            //             });
                            //             if (exists == false) {
                            //                 _this.items.push({
                            //                     name: rowItem.name,
                            //                     id: rowItem.id
                            //                 });
                            //             }
                            //         }
                            //     }
                            // });
                        }
                    });
                    _this.loading = false;
                })
                .catch(err => {
                    _this.loading = false;
                });
        },
        viewOccurrenceComments(occurrence){
            this.modalComment = {
                comment: "",
                file: null,
                fileName: "Clique para selecionar o arquivo"
            };
            this.selectedOccurrence = occurrence;
            $("#modalOccurenceComment").modal('show');
            this.loadComments();
        },
        loadComments(){
            if(this.selectedOccurrence.id != null){
                let _this = this;
                _this.loading = true;
                _this.occurrenceComments = [];
                var params = {
                    page: _this.tablePaginationOptionsComments.currentPage,
                    perPage: _this.tablePaginationOptionsComments.currentPerPage,
                };
                axios.post("/admin/occurrences/" + _this.selectedOccurrence.id + "/comments", {}, {params: params}).then((res) => {
                    const { data, total, from, to } = res.data.data;
                    _this.tablePaginationOptionsComments.total = total;
                    _this.tablePaginationOptionsComments.from = from;
                    _this.tablePaginationOptionsComments.to = to;
                    _this.occurrenceComments = [...data];
                    _this.loading = false;
                }).catch((err) => {
                    _this.loading = false;
                });
            }
        },
        saveComment(){
            let _this = this;
            _this.errors = [];
            _this.message = "";
            _this.loading = true;

            let formData = new FormData();
            formData.append("comment", _this.modalComment.comment);
            formData.append("file", _this.modalComment.file);

            axios.post("/admin/occurrences/" + _this.selectedOccurrence.id + "/comment", formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {

                _this.loading = false;

                _this.modalComment = {
                    comment: "",
                    file: null,
                    fileName: "Clique para selecionar o arquivo"
                };

                _this.loadComments();

                //call function in ApiService to validate success
                _this._api_validateSuccess(res,false);

            }).catch((err) => {

                _this.loading = false;

                if (err.response.data.errors){
                    //set errors
                    _this.errors = err.response.data.errors;
                }

                //call function in ApiService to validate error
                _this._api_validateError(err);

            });
        },
        viewCommentFile(row){
            if(row.file != null && row.file != undefined){
                window.open('https://mvtecnologiaegestao.com/storage/' + 'occurrences/' + row.file, '_blank');
            }
        }
    }
};
</script>
